/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PerformancePageDto } from '../../models/performance-page-dto';

export interface GetPerformanceReports$Params {
  authorId?: number;
  customerId?: number;
  facilityGroupId?: number;
  facilityId?: number;
  publishedOnly?: boolean;
}

export function getPerformanceReports(http: HttpClient, rootUrl: string, params?: GetPerformanceReports$Params, context?: HttpContext): Observable<StrictHttpResponse<PerformancePageDto>> {
  const rb = new RequestBuilder(rootUrl, getPerformanceReports.PATH, 'get');
  if (params) {
    rb.query('authorId', params.authorId, {});
    rb.query('customerId', params.customerId, {});
    rb.query('facilityGroupId', params.facilityGroupId, {});
    rb.query('facilityId', params.facilityId, {});
    rb.query('publishedOnly', params.publishedOnly, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PerformancePageDto>;
    })
  );
}

getPerformanceReports.PATH = '/api/facilitystatusreport/performance';
